module.exports = __webpack_public_path__ + "static/media/noticias-mujer.af8ca473.png";